import type { Hydratable } from '@vimcar/mvvm/hydratable'

import * as dataMapper from '@vimcar/mvvm/dataMapper'
import hydratable from '@vimcar/mvvm/hydratable'
import * as mobx from 'mobx'

import type { Nodes, ContentType, NodeTypes } from '../'

type _CheckboxesNode = {
  contentModelType: ContentType
  options: Array<string>
  nextNode?: NodeTypes | null
}

// @ts-expect-error@2314
export type CheckboxesNode = Hydratable<
  _CheckboxesNode,
  {
    id: string
    title: string
    text?: string | null
    subtext?: string | null
    required: boolean
    _options?: Array<string> | null
    _nextNode: Array<{ sys: { id: string } }>
  } & _CheckboxesNode
>

type Options = { nodes: Nodes }

const mkCheckboxesNode = hydratable(
  ({ nodes }: Options) => {
    const checkboxesNode = mobx.observable({
      contentModelType: 'checkboxesNode',

      get options() {
        // @ts-expect-error@2551
        return checkboxesNode._options || []
      },

      get nextNode() {
        return (
          // @ts-expect-error@2551
          checkboxesNode._nextNode && nodes.get(checkboxesNode._nextNode.sys.id)
        )
      },
    } as _CheckboxesNode)

    return checkboxesNode
  },
  'CheckboxesNode',
  {
    fields: dataMapper.lift({
      title: false,
      text: false,
      subtext: false,
      options: '_options',
      required: false,
      nextNode: '_nextNode',
    }),
    sys: dataMapper.lift({
      id: true,
    }),
  },
)

export default mkCheckboxesNode
